import React, { useState, useContext, useEffect } from "react";
import { shopify_url } from 'config'

import { 
  Link,
  TextField,
  Box,
  Button,
  InputAdornment,
  Typography,
  Alert
} from '@mui/material';

import { square_url } from 'config';
import { AuthContext } from 'components';

export const IntegrationSquare = (props) => {
  const { accountIntegrations, updateSquareIntegration } = useContext(AuthContext);
  const [ shop, setShop ] = useState("")
  const [ squareConnection, setSquareConnection ] = useState(false)
  const [ error, setError ] = useState(false)
  // const square_api_domain = 'https://4e463e5082a4.ngrok.app';
  const square_api_domain = square_url;

  useEffect(() => {
    setSquareConnection(accountIntegrations?.square || false)
  }, [accountIntegrations])

  const handleClick = () => {
    const square_url = `${square_api_domain}/square/login/`;
    window.open(`${square_url}?redirect_url=${window.location.href}`)?.focus();
  }

  const handleDisconnect = () => {
    const square_url = `${square_api_domain}/square/revoke_token/`;
    window.open(`${square_url}?token=${squareConnection?.access_token}`)?.focus();
    updateSquareIntegration(false, () => {

    })
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', mt: 4 }}>
      {squareConnection ? (
        <>
          <Alert severity="success">Square account connected.</Alert>
          <Button sx={{ maxWidth: 200, padding: '8px 16px', marginBottom: '2px', marginLeft: '2px' }} variant='outlined' color="error" onClick={handleDisconnect}>Disconnect</Button>
        </>
      ) : (
        <>
          <Typography sx={{ width: '100%' }} variant="h5">Connect Square Account</Typography>
          <Button sx={{ maxWidth: 200, padding: '8px 16px', marginBottom: '2px' }} variant={shop?'contained':'outlined'} color="secondary" onClick={handleClick}>Connect</Button>
        </>
      )}
    </Box>
  );
};
